
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function RalliesPage() {
  const rallyTypes = [
    {
      title: 'Street Evangelism',
      description: 'Taking the Gospel directly to the streets and communities',
      icon: 'ri-road-map-line',
      activities: ['Open-air preaching', 'Gospel distribution', 'Personal evangelism', 'Street testimonies']
    },
    {
      title: 'Community Outreach',
      description: 'Engaging local communities with practical demonstrations of love',
      icon: 'ri-community-line',
      activities: ['Community service', 'Health screenings', 'Food distribution', 'Youth programs']
    },
    {
      title: 'Public Worship',
      description: 'Creating altars of worship in public spaces',
      icon: 'ri-music-line',
      activities: ['Praise and worship', 'Public prayer', 'Prophetic declarations', 'Spiritual warfare']
    },
    {
      title: 'Territorial Impact',
      description: 'Establishing spiritual influence across regions',
      icon: 'ri-flag-line',
      activities: ['Prayer walks', 'Territorial declarations', 'Spiritual mapping', 'Kingdom advancement']
    }
  ];

  const upcomingRallies = [
    {
      title: 'Lagos City Rally',
      location: 'Victoria Island, Lagos',
      date: 'Every Saturday',
      time: '4:00 PM - 7:00 PM',
      focus: 'Street Evangelism & Community Outreach'
    },
    {
      title: 'Abuja Unity Rally',
      location: 'Central Business District',
      date: 'First Sunday Monthly',
      time: '3:00 PM - 6:00 PM',
      focus: 'Public Worship & Territorial Prayer'
    },
    {
      title: 'Port Harcourt Revival Rally',
      location: 'Mile 1 Market Area',
      date: 'Every Friday',
      time: '5:00 PM - 8:00 PM',
      focus: 'Street Preaching & Healing Ministry'
    }
  ];

  const testimonials = [
    {
      name: 'Brother Emmanuel Okafor',
      location: 'Lagos Rally Team',
      testimony: 'Through JCR street evangelism, I\'ve seen over 200 people give their lives to Christ in the past year. The power of God moves mightily in the streets.',
      image: 'https://readdy.ai/api/search-image?query=Young%20African%20man%20street%20evangelist%20with%20Bible%2C%20simple%20background%2C%20warm%20lighting%2C%20joyful%20expression%2C%20ministry%20context%2C%20authentic%20portrait%20style&width=300&height=300&seq=rally1&orientation=squarish'
    },
    {
      name: 'Sister Grace Adebayo',
      location: 'Abuja Rally Coordinator',
      testimony: 'The community rallies have transformed our neighborhood. People now look forward to our weekly outreach programs and many have joined CFN centers.',
      image: 'https://readdy.ai/api/search-image?query=African%20woman%20community%20outreach%20worker%2C%20simple%20background%2C%20warm%20lighting%2C%20compassionate%20expression%2C%20ministry%20context%2C%20authentic%20portrait%20style&width=300&height=300&seq=rally2&orientation=squarish'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(184, 20, 74, 0.8), rgba(184, 20, 74, 0.8)), url('https://readdy.ai/api/search-image?query=Street%20evangelism%20rally%20in%20African%20city%2C%20people%20gathering%20for%20outdoor%20worship%2C%20community%20engagement%2C%20simple%20background%2C%20warm%20evening%20lighting%2C%20spiritual%20atmosphere%2C%20public%20ministry%20context&width=1920&height=800&seq=rallyhero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">Jesus Christ Rally</h1>
          <p className="text-xl max-w-4xl mx-auto mb-8">
            Community street evangelism and altar of worship movement across territories
          </p>
          <Link 
            to="/join"
            className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Join a Rally
          </Link>
        </div>
      </section>

      {/* Rally Types */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Rally Activities</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Jesus Christ Rally (JCR) brings the Gospel to the streets through various forms of 
              community engagement and public worship.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {rallyTypes.map((type, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-lg">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mr-4">
                    <i className={`${type.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">{type.title}</h3>
                    <p className="text-gray-600">{type.description}</p>
                  </div>
                </div>
                <div className="space-y-2">
                  {type.activities.map((activity, actIndex) => (
                    <div key={actIndex} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-[#b8144a] mr-3"></i>
                      <span>{activity}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Upcoming Rallies */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Upcoming Rallies</h2>
            <p className="text-xl text-gray-600">Join us for regular community outreach events</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {upcomingRallies.map((rally, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-4">{rally.title}</h3>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-gray-700">
                    <i className="ri-map-pin-line text-[#b8144a] mr-3"></i>
                    <span className="text-sm">{rally.location}</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <i className="ri-calendar-line text-[#b8144a] mr-3"></i>
                    <span className="text-sm">{rally.date}</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <i className="ri-time-line text-[#b8144a] mr-3"></i>
                    <span className="text-sm">{rally.time}</span>
                  </div>
                  <div className="flex items-start text-gray-700">
                    <i className="ri-focus-line text-[#b8144a] mr-3 mt-1"></i>
                    <span className="text-sm">{rally.focus}</span>
                  </div>
                </div>
                <Link 
                  to="/join"
                  className="bg-[#b8144a] hover:bg-[#a01240] text-white px-6 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer w-full text-center block"
                >
                  Join This Rally
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Rally Impact */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Rally Impact</h2>
              <p className="text-lg text-gray-700 mb-6">
                Jesus Christ Rally has become a powerful movement that transforms communities 
                through consistent street evangelism and public worship.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <p className="text-3xl font-bold text-[#b8144a]">50+</p>
                  <p className="text-gray-600">Active Rally Teams</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-[#b8144a]">25,000+</p>
                  <p className="text-gray-600">Souls Reached</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-[#b8144a]">100+</p>
                  <p className="text-gray-600">Cities Covered</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold text-[#b8144a]">5,000+</p>
                  <p className="text-gray-600">Salvations</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Street%20evangelism%20team%20in%20action%2C%20African%20community%20setting%2C%20people%20sharing%20Gospel%2C%20simple%20background%2C%20warm%20lighting%2C%20ministry%20impact%2C%20community%20transformation%20context&width=600&height=400&seq=rallyimpact&orientation=landscape"
                alt="Rally Impact"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Rally Testimonies</h2>
            <p className="text-xl text-gray-600">Stories from the streets</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-lg shadow-lg">
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">{testimonial.name}</h3>
                    <p className="text-[#b8144a] font-medium">{testimonial.location}</p>
                  </div>
                </div>
                <p className="text-gray-700 italic">"{testimonial.testimony}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Join */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">How to Join JCR</h2>
            <p className="text-xl text-gray-600">Steps to become part of the street evangelism movement</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Complete PAAM Training</h3>
              <p className="text-gray-700 text-sm">Finish the 60-day Global Mandate Training Program</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Join CFN Center</h3>
              <p className="text-gray-700 text-sm">Connect with a local Christ Family Network center</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Evangelism Training</h3>
              <p className="text-gray-700 text-sm">Receive specialized training for street evangelism</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">4</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Start Rallying</h3>
              <p className="text-gray-700 text-sm">Join or start a JCR team in your community</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Take Christ to the Streets</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Join Jesus Christ Rally and become part of the movement that brings the Gospel 
            directly to communities through street evangelism and public worship.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join a Rally Team
            </Link>
            <Link 
              to="/training"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Evangelism Training
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
